<div class="layout-content">
	<form (ngSubmit)="submit()" [formGroup]="specialDayForm">
		<div *ngIf="saving">
			<div class="flex align-items-center justify-content-center w-full pb-8 mb-8">
				<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
			</div>
		</div>
		<div class="grid" *ngIf="!saving">
			<div class="col-12" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.date, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.date, 'label')">{{ 'DATE' | translate }}</div>
					<div #borderInput class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.date, 'borderInput')">
						<p-calendar [showIcon]="true" inputId="icon" formControlName="date" appendTo="body"
							placeholder="dd/mm/yyyy" [minDate]="minDate" dateFormat="dd/mm/yy"
							[ngClass]="dynamicInputTextWidth()" [styleClass]="dynamicInputTextWidth()"
							inputStyleClass="pl-6 border-noround-right">
						</p-calendar>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.date)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.modality,'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.modality,'label')">{{ 'MODALITY' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.modality,'borderInput')">
						<p-dropdown [options]="listModality" [ngClass]="dynamicInputTextWidth()" pAutoFocus [autofocus]="true"
							styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5" formControlName="modality"
							placeholder="{{ 'MODALITY' | translate }}" optionValue="Value" dataKey="Value">
							<ng-template let-item pTemplate="selectedItem">
								<div class="item" class="flex align-items-center justify-content-center">
									<div class="flex justify-content-center">{{ item.Name | translate}}</div>
								</div>
							</ng-template>
							<ng-template let-item pTemplate="item">
								<div class="item flex align-items-center justify-content-center">
									<div>{{ item.Name | translate}}</div>
								</div>
							</ng-template>
						</p-dropdown>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.modality)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div [ngClass]="col12Responsive()" *ngIf="this.f.modality.value === 2">
				<div class="flex justify-content-between flex-wrap"
					[ngClass]="newShowErrors(this.f.startTime, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.startTime, 'label')">{{ 'START_TIME' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.startTime, 'borderInput')">
						<p-calendar [showIcon]="true" inputId="icon" formControlName="startTime" appendTo="body"
							timeOnly="true" [ngClass]="dynamicInputShortTextWidth()"
							[styleClass]="dynamicInputShortTextWidth()" inputStyleClass="pl-6 border-noround-right">
						</p-calendar>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.startTime)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div [ngClass]="col12Responsive()" *ngIf="this.f.modality.value === 2">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.endTime, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.endTime, 'label')">{{ 'END_TIME' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.endTime, 'borderInput')">
						<p-calendar [showIcon]="true" inputId="icon" formControlName="endTime" appendTo="body" timeOnly="true"
							[ngClass]="dynamicInputShortTextWidth()" [styleClass]="dynamicInputShortTextWidth()"
							inputStyleClass="pl-6 border-noround-right">
						</p-calendar>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.endTime)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}. {{ 'TAG_DATE_WARNING_INVALID' | translate }}</small>
			</div>
		</div>

		<div class="grid mt-8 mb-1 mx-1 flex justify-content-center align-items-center" *ngIf="!saving">
			<button type="submit" pButton pRipple label="{{ 'CONFIRM' | translate }}"
				class="p-button-primary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
			<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CANCEL' | translate }}"
				class="p-button-secondary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
		</div>
	</form>
</div>